import container from "@/lib/di/container";
import { useEffect, useState } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { DetailModal } from "./modals/DetailModal";
import { Button, message, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { UserRequestModel, UserRequestModelFactory } from "@/core/models/user-request.model";
import { UserRequestRepo } from "@/core/repos/tables/user-request.repo";
import { requestTypePipe } from "@/core/pipes/request-type.pipe";
import { requestStatusPipe, requestStatusTagPipe } from "@/core/pipes/request-status.pipe";
import { DeleteButton } from "../../components/table/DeleteButton";
import { UserRequestStatus, UserRequestType } from "@/core/enums/global.enums";

const userRequestRepo = container.get(UserRequestRepo);

export default function CustomerRequestPage() {
    const [modalData, setModalData] = useState<UserRequestModel>(UserRequestModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<UserRequestModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tìm kiếm",
            placeholder: "Nhập nội dung tìm kiếm",
            type: FilterInputType.text,
        },
        {
            dataIndex: "status",
            label: "Trạng thái",
            placeholder: "Chọn trạng thái",
            type: FilterInputType.select,
            options: [
                { value: UserRequestStatus.Pending, name: requestStatusPipe(UserRequestStatus.Pending) },
                { value: UserRequestStatus.InProcess, name: requestStatusPipe(UserRequestStatus.InProcess) },
                { value: UserRequestStatus.Completed, name: requestStatusPipe(UserRequestStatus.Completed) },
                { value: UserRequestStatus.Cancelled, name: requestStatusPipe(UserRequestStatus.Cancelled) },
            ]
        },
        {
            dataIndex: "requestType",
            label: "Loại yêu cầu",
            placeholder: "Chọn loại yêu cầu",
            type: FilterInputType.select,
            options: [
                { value: UserRequestType.Leak, name: requestTypePipe(UserRequestType.Leak) },
                { value: UserRequestType.WaterLoss, name: requestTypePipe(UserRequestType.WaterLoss) },
                { value: UserRequestType.WaterQuality, name: requestTypePipe(UserRequestType.WaterQuality) },
                { value: UserRequestType.Payment, name: requestTypePipe(UserRequestType.Payment) },
                { value: UserRequestType.Meter, name: requestTypePipe(UserRequestType.Meter) },
                { value: UserRequestType.Other, name: requestTypePipe(UserRequestType.Other) },
            ]
        },
    ])

    const showDetail = (record: UserRequestModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const init = async () => {}

    useEffect(()=>{init()}, []);

    const deleteSelected = async () => {
        setDeleting(true);
        const result = await userRequestRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }


    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: UserRequestModel[]) {
        setSelectedRows([...rows]);
    }

    return (
    <div className="px-4 py-6">

        
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<UserRequestModel>
                columns={[
                    { dataIndex: 'code', name: 'Mã yêu cầu' },
                    { dataIndex: 'name', name: 'Tên khách hàng' },
                    { dataIndex: 'requestType', name: 'Phân loại', pipe: requestTypePipe},
                    { dataIndex: 'description', name: 'Nội dung' },
                    { dataIndex: 'phone', name: 'Số điện thoại' },
                    { dataIndex: 'address', name: 'Địa chỉ' },
                    { dataIndex: 'createdAt', name: 'Thời gian gửi', pipe: formatDateTimePipe },
                    { dataIndex: 'updatedAt', name: 'Thời gian cập nhật', pipe: formatDateTimePipe },
                    { dataIndex: 'status', name: 'Trạng thái', fixed: "right", pipe: (value: string) => requestStatusTagPipe(value)},
                    {
                        name: 'Thao tác',
                        render: (_, record) => (
                            <div className="flex flex-row px-1 items-center justify-center">
                                <Tooltip title="Xem chi tiết yêu cầu khách hàng"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                            </div>
                        ),
                        fixed: "right",
                    },
                ]}
                repository={userRequestRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
    </div>)
}